// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--EhwFB","root":"root--RRn2t","noRightsWrapper":"noRightsWrapper--Q7WnT","bold":"bold--loz5D","tabs":"tabs--lGDNe","search":"search--IejpT"};